import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  salaryList: [],
  salaryById: {},
  loading :{
    create : false,
    update : false,
    delete : false,
    read : false,
    getById : false,
  },
  error: false,
  errorMessage: "",
};

const salarySlice = createSlice({
  name: "salary",
  initialState,
  reducers: {
    getSalaryList(state, action) {
      state.salaryList = action.payload;
      state.loading.read = false;
    },
    salaryByIdData(state, action) {
      state.salaryById = action.payload;
      state.loading.getById = false;
    },
    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
      state.loading = false;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    loadingData(state, action) {
      const { type, value } = action.payload;
    
      if (typeof state.loading !== "object" || state.loading === null) {
        state.loading = {
          read: false,
          create: false,
          update: false,
        };
      }
    
      state.loading[type] = value;
    },
  },
});

export const {
  getSalaryList,
  salaryByIdData,
  errorMessages,
  loadingData,
  hideErrorMessage,
} = salarySlice.actions;

export default salarySlice.reducer;
